// The category menu of the web shop (dm-commerce-b2b-web src/utils/product-category/product-category.ts): each
// category with its subcategories as [search tag, name]. A discount is set on these tags. Keep in step with that list.
export const SHOP_CATEGORIES = [
  {
    "tag": "bags",
    "name": "Bags",
    "subs": [
      ["purse", "Purse"],
      ["bags", "Bags"],
      ["briefcase", "Briefcase"],
      ["money-clip", "Money Clip"],
      ["wallet", "Wallet"],
      ["backpack", "Backpack"],
      ["travel-bag", "Travel Bag"],
      ["card-holder", "Card Holder"],
      ["laptop-bag", "Laptop Bag"],
      ["suitcase", "Suitcase"],
      ["waist-bag", "Waist Bag"],
      ["hand-bag", "Hand Bag"],
      ["gift-box", "Gift Box"]
    ]
  },
  {
    "tag": "shoes",
    "name": "Shoes",
    "subs": [
      ["men-shoes", "Men Shoes"],
      ["men-boots", "Men Boots"],
      ["ladies-shoes", "Ladies Shoes"],
      ["ladies-boot", "Ladies Boot"],
      ["high-heels", "High Heels"],
      ["formal-shoes", "Formal Shoes"],
      ["sandals", "Sandals"],
      ["running-shoes", "Running Shoes"],
      ["casual-shoes", "Casual Shoes"],
      ["loafers", "Loafers"],
      ["sports-shoes", "Sports Shoes"],
      ["baby-shoes", "Baby Shoes"],
      ["low-top-shoes", "Low Top Shoes"],
      ["rain-boots", "Rain Boots"],
      ["football-shoes", "Football Shoes"],
      ["slippers", "Slippers"]
    ]
  },
  {
    "tag": "jewelry",
    "name": "Jewelry",
    "subs": [
      ["men-bracelets", "Men Bracelets"],
      ["women-bracelets", "Women Bracelets"],
      ["earrings", "Earrings"],
      ["jewelry-cases", "Jewelry Cases"],
      ["necklace", "Necklace"],
      ["bridal-jewelry", "Bridal Jewelry"],
      ["crown", "Crown"],
      ["pendant", "Pendant"],
      ["bangle", "Bangle"],
      ["ring", "Ring"],
      ["anklet", "Anklet"],
      ["tiara", "Tiara"],
      ["belly-chain", "Belly Chain"],
      ["jewelry-box", "Jewelry Box"],
      ["pin-brooch", "Pin Brooch"],
      ["fashion-jewelry", "Fashion Jewelry"]
    ]
  },
  {
    "tag": "beauty-products",
    "name": "Beauty",
    "subs": [
      ["eyeshadow", "Eyeshadow"],
      ["eyeliner", "Eyeliner"],
      ["earrings", "Earrings"],
      ["face-cream", "Face Powder"],
      ["makeup-remover", "Makeup Remover"],
      ["eye-brushes", "Eye Brushes"],
      ["hair-removal", "Hair Removal"],
      ["mirror", "Mirror"],
      ["teeth-whitening", "Teeth Whitening"],
      ["nail-polish", "Nail Polish"],
      ["lip-gloss", "Lip Gloss"],
      ["lip-liner", "Lip Liner"],
      ["lipstick", "Lipstick"],
      ["anti-hair-loss", "Anti Hair Loss"],
      ["hairspray", "Hairspray"],
      ["hair-dryers", "Hair Dryers"],
      ["hair-dye", "Hair Dye"],
      ["hair-oil", "Hair Oil"],
      ["shower-gel", "Shower Gel"],
      ["candles", "Candles"],
      ["lotion", "Lotion"],
      ["perfume", "Perfume"],
      ["perfume-set", "Perfume Set"],
      ["deodorant", "Deodorant"],
      ["soap", "Soap"],
      ["body-wash", "Body Wash"],
      ["hair-conditioner", "Hair Conditioner"],
      ["toner", "Toner"],
      ["facial-mask", "Facial Mask"],
      ["face-moisturizer", "Face Moisturizer"],
      ["face-serum", "Face Serum"],
      ["sunscreen", "Sunscreen"]
    ]
  },
  {
    "tag": "mens-clothing",
    "name": "Mens",
    "subs": [
      ["casual-pants-men", "Casual Pants For Men"],
      ["jeans-men", "Mens Jeans Pant"],
      ["suit-men", "Men Suit"],
      ["leather-jackets-men", "Leather Jackets For Men"],
      ["trousers-men", "Trouser"],
      ["shirt-men", "Shirts"],
      ["shorts-men", "Shorts"],
      ["tie-clips", "Tie Clips"],
      ["mens-sweater", "Mens Sweater"],
      ["underwear-boxer", "Boxers"],
      ["mens-hat", "Mens Hat"],
      ["leather-gloves", "Leather Gloves"],
      ["sweatpants-men", "Men Sweatpants"],
      ["socks-men", "Socks"],
      ["tie-men", "Tie"],
      ["bow-ties", "Bow Ties"],
      ["gloves", "Gloves"]
    ]
  },
  {
    "tag": "womens-clothing",
    "name": "Womens",
    "subs": [
      ["hoodies-women", "Hoodies & Sweatshirts"],
      ["suits-women", "Womens Suits Blazers"],
      ["bodysuits-women", "Bodysuits"],
      ["jacket-women", "Coats Jackets"],
      ["swimwear-women", "Swimwear"],
      ["bikini-set", "Bikini Set"],
      ["skirt", "Skirt"],
      ["womens-jeans", "Womens Jeans"],
      ["wedding-dresses", "Wedding Dresses"],
      ["prom-dresses", "Prom Dresses"],
      ["evening-dresses", "Evening Dresses"],
      ["cosplay-costumes", "Cosplay Costumes"],
      ["bra", "Bra"],
      ["panties", "Panties"],
      ["women-socks", "Women Socks"],
      ["bucket-hats", "Bucket Hats"],
      ["belt-women", "Belts"]
    ]
  },
  {
    "tag": "baby-items",
    "name": "Baby",
    "subs": [
      ["baby-bottle", "Baby Bottle"],
      ["diapers", "Diapers"],
      ["potty-&-washing", "Potty & Washing"],
      ["water-toys", "Water Toys"],
      ["remote-control-toys", "Remote Control Toys"],
      ["baby-gift-set", "Baby Gift Set"],
      ["baby-dress", "Baby Dress"],
      ["baby-socks", "Baby Socks"],
      ["baby-swimsuit", "Baby Swimsuit"],
      ["baby-jacket", "Baby Jacket"],
      ["baby-skirt", "Baby Skirt"],
      ["baby-sweater", "Baby Sweater"],
      ["baby-shoes", "Baby Shoes"],
      ["baby-sports-shoes", "Baby Sports Shoes"]
    ]
  },
  {
    "tag": "sunglass",
    "name": "Sunglass",
    "subs": [
      ["sunglass", "Sunglass"],
      ["women-sunglass", "Women Sunglass"],
      ["baby-sunglasses", "Baby Sunglasses"],
      ["party-sunglass", "Party Sunglass"],
      ["goggles", "Goggles"],
      ["reading-glasses", "Reading Glasses"]
    ]
  },
  {
    "tag": "phone-accessories",
    "name": "Accessories",
    "subs": [
      ["xiaomi", "Xiaomi"],
      ["apple", "Apple"],
      ["huawei", "Huawei"],
      ["realme", "Realme"],
      ["one-plus", "One Plus"],
      ["samsung", "Samsung"],
      ["google", "Google"],
      ["vivo-smartphone", "Vivo"],
      ["nokia", "Nokia"],
      ["lg", "LG"],
      ["tecno", "Tecno"],
      ["htc", "HTC"],
      ["motorola", "Motorola"],
      ["asus", "Asus"]
    ]
  },
  {
    "tag": "fitness",
    "name": "Fitness",
    "subs": [
      ["snowboard", "Snowboard"],
      ["jet-ski", "Jet Ski"],
      ["swimming", "Swimming"],
      ["fishing-rod", "Fishing Rod"],
      ["bbq", "Grills & Bbq Equipment"],
      ["luggage-lock", "Luggage Lock"],
      ["yoga", "Yoga"],
      ["tent", "Tent"]
    ]
  },
  {
    "tag": "watches",
    "name": "Watches",
    "subs": [
      ["watch", "Watch"],
      ["womens-watch", "Womens Watch"],
      ["mens-watches", "Mens Watches"],
      ["smart-watch", "Smart Watch"],
      ["gshock", "Gshock"],
      ["apple-watch", "Apple Watch"],
      ["fit-band", "Fit Band"]
    ]
  },
  {
    "tag": "food-items",
    "name": "Food",
    "subs": [
      ["breakfast", "Breakfast"],
      ["laundry-&-household", "Laundry & Household"],
      ["cat", "Cat"],
      ["cat-bag", "Cat Bag"],
      ["dog", "Dog"],
      ["fish", "Fish"],
      ["bird", "Bird"],
      ["small-pet", "Small Pet"]
    ]
  },
  {
    "tag": "traveling",
    "name": "Traveling",
    "subs": [
      ["fishing-reel", "Fishing Reel"],
      ["fishing", "Fishing"],
      ["fishing-line", "Fishing Line"],
      ["fishing-rod", "Fishing Rod"],
      ["sportswear", "Sportswear"],
      ["sports-bag", "Sports Bag"],
      ["sport-accessories", "Sport Accessories"],
      ["camping-&-hiking", "Camping & Hiking"],
      ["hunting", "Hunting"],
      ["fitness-&-bodybuilding", "Fitness & Bodybuilding"],
      ["skiing-&-snowboarding", "Skiing & Snowboarding"]
    ]
  },
  {
    "tag": "gadgets",
    "name": "Gadgets",
    "subs": [
      ["electronics", "Electronics"],
      ["camera", "Camera"],
      ["mobile-accessories", "Mobile Accessories"],
      ["computer-accessories", "Computer Accessories"],
      ["gps-&-navigation", "Gps & Navigation"],
      ["speaker", "Speaker"],
      ["security-&-surveillance", "Security & Surveillance"],
      ["tv", "Television"],
      ["projector", "Projector"]
    ]
  }
];
